module.exports = __webpack_public_path__ + "img/walnut_brown.13ca4d7.png";